import { NgModule, ModuleWithProviders } from "@angular/core";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { RemoteGatewayFactory } from "./remote-gateway-factory";
import { RouteStrategyFactory } from "./route-strategy-factory";

@NgModule({ imports: [], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class GatewayModule {
  static forRoot(): ModuleWithProviders<GatewayModule> {
    return {
      ngModule: GatewayModule,
      providers: [RemoteGatewayFactory, RouteStrategyFactory],
    };
  }
}
